import TimelineVideo from "../../../../timeline/TimelineVideo/TimelineVideo";

const VideoPreview = require('../../../../../assets/img/timeline/modal/2017-rebranding.jpg');

const NewNameContent = () => {
    return (
        <>
            <TimelineVideo videoId="LF_fz1yl48g" imagePreview={VideoPreview} />
            <h4>
                Our new name - Breast Cancer Trials - is launched
            </h4>
            <p>
                The Australia and New Zealand Breast Cancer Trials Group and our fundraising department the Breast Cancer Institute of Australia, are rebranded to form one new name - Breast Cancer Trials. Our new name clearly describes who we are and what we do. The map in the logo not only represents our trials in Australia and New Zealand but is also a fingerprint, which speaks to the tailoring of treatments for every person.
            </p>
        </>
    );
}

export default NewNameContent;